import { useEffect, useState } from "react";
import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { GetBidReportQuery } from "lib/generated/app-service-gql/graphql";
import { BidNoBidResponse, useGetBidReport } from "./useGetBidReport";
import { useQualifyBid } from "./useQualifyBid";

export function useGetOrQualifyBid(
  id: string,
  options?: UseQueryOptions<GetBidReportQuery, unknown, GetBidReportQuery, QueryKey>,
) {
  const {
    data: reportResult,
    isLoading: reportLoading,
    isError: reportError,
    error: reportErrorObj,
  } = useGetBidReport(id, {
    ...options,
  });

  const [qualifiedResult, setQualifiedResult] = useState<BidNoBidResponse | null>(null);
  const [hasTriggered, setHasTriggered] = useState(false);

  const {
    mutate: qualifyBid,
    isLoading: qualifyLoading,
    isError: qualifyError,
    error: qualifyErrorObj,
  } = useQualifyBid({
    onSuccess: (data) => {
      setQualifiedResult(data.qualifyBid.result);
    },
  });

  // Run qualifyBid if query returned an empty result
  useEffect(() => {
    const isEmpty = Array.isArray(reportResult) && reportResult.length === 0;

    if (!!window.currentUser && !reportLoading && isEmpty && !hasTriggered) {
      qualifyBid({ id });
      setHasTriggered(true);
    }
  }, [reportLoading, reportResult, hasTriggered, qualifyBid, id]);

  // Determine which result to return
  const finalData = qualifiedResult ?? reportResult;

  const isLoading = reportLoading || qualifyLoading;
  const isError = reportError || qualifyError;
  const error = qualifyErrorObj ?? reportErrorObj;

  return {
    data: finalData,
    isLoading,
    isError,
    error,
  };
}
